import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

export const HandoffMessage = ({ message, isVisible = true }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  // Check if text is truncated
  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    };
    
    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [message]);

  if (!isVisible || !message) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -5 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      className="py-2 pl-10"
      data-testid="handoff-message"
    >
      <div className="flex items-start gap-1.5 text-[11px] text-gray-500 bg-slate-800/40 px-3 py-1.5 rounded-lg">
        <span className="text-gray-600 flex-shrink-0 mt-px">↳</span>
        <div className="flex-1 min-w-0 flex items-baseline gap-1">
          <span 
            ref={textRef}
            className={isExpanded ? 'leading-relaxed' : 'truncate'}
          >
            {message}
          </span>
          {(isTruncated || isExpanded) && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-gray-600 hover:text-gray-400 flex-shrink-0 text-[10px]"
            >
              {isExpanded ? 'less' : 'more'}
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default HandoffMessage;
